export default function closeModal(query) {
	query.delete('modal');
	query.delete('id');
	query.delete('fromModal');
	query.delete('fromId');
	query.delete('mode');
	query.delete('tab');
	query.delete('req_id');
	query.delete('fromTab');
	query.delete('contactsSearch');
	query.delete('childrenSorts');
	query.delete('childrenFilters');
	query.delete('modalSorts');
	query.delete('modalFilters');
	query.delete('express');
	query.delete('process_id');
	query.delete('transportId');
	query.delete('addressId');
}
